import React, { useState } from "react";
import { BrandLogo } from "../header/BrandLogo";
import { DesktopNav, HeaderActions, useNavLinks } from "../header/DesktopNav";
import { MobileLicenseStrip } from "../header/MobileLicenseStrip";
import { MobileMenu } from "../header/MobileMenu";

export default function Header({ t, lang, setLang }) {
  const [open, setOpen] = useState(false);
  const navLinks = useNavLinks(t);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-brand"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 h-16 md:h-20 flex items-center justify-between">
        <BrandLogo t={t} />
        <DesktopNav navLinks={navLinks} />
        <HeaderActions t={t} lang={lang} setLang={setLang} open={open} onToggle={() => setOpen(!open)} />
      </div>

      <MobileLicenseStrip t={t} />

      {open && (
        <MobileMenu t={t} lang={lang} setLang={setLang} navLinks={navLinks} onNavigate={() => setOpen(false)} />
      )}
    </header>
  );
}
